import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default ({
  title,
  ...extra
}) => /*#__PURE__*/_jsxs("svg", {
  height: "43.627",
  width: "50",
  viewBox: "0 0 50 43.627",
  fill: "#1aa",
  ...extra,
  children: [title, /*#__PURE__*/_jsx("path", {
    fillOpacity: "0.8",
    d: "M25.365 21.4H49.97L37.73.064V.03h-.03V0l-.032.03H13"
  }), /*#__PURE__*/_jsx("path", {
    fillOpacity: "0.6",
    d: "M50 22.036H25.3L13 43.596h24.57v.032l.033-.032h.03l-.03-.032"
  }), /*#__PURE__*/_jsx("path", {
    d: "M24.857 21.687L12.46.222.032 21.845H0l.032.032L0 21.91h.032l12.302 21.464"
  })]
});